import styled from 'styled-components'
import { colors } from '../../theme'

export const Button = styled.button<{ isOnHigh: boolean }>`
  border: none;
  cursor: pointer;
  padding: 6px 20px;
  border-radius: 8px;
`
export const ButtonHigh = styled(Button)`
  background-color: ${({ isOnHigh }) =>
    isOnHigh ? `${colors.accentBg}` : `${colors.grey100}`};
  color: ${({ isOnHigh }) =>
    isOnHigh ? `${colors.white}` : `${colors.grey500}`};
  margin: 0 5px;
  width: 85px;
  font-size: 10px;
  font-weight: 600;
`
export const ButtonLow = styled(Button)`
  background-color: ${({ isOnHigh }) =>
    isOnHigh ? `${colors.grey100}` : `${colors.error}`};
  color: ${({ isOnHigh }) =>
    isOnHigh ? `${colors.grey500}` : `${colors.white}`};
  margin: 0 5px;
  width: 90px;
  font-size: 10px;
  font-weight: 600;
`
export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2px;
  width: 190px;
`
